//防抖动函数: 定义一个定时器给予时间后判断下一次重复调用这个定时器的时间间隔如果太短那么将取消上次调用
export function debonun(func, delay = 100) {
    let timer = null;
    return function(...ages) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, ages);
        }, delay)
    }
}


// 时间戳的时间格式化
export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
};

//按钮防抖
export const DebounceBy = (fn, t) => {
        let delay = t || 500
        let timer
        return function() {
            let args = arguments;
            if (timer) {
                clearTimeout(timer)
            }

            let callNow = !timer

            timer = setTimeout(() => {
                timer = null
            }, delay)

            if (callNow) fn.apply(this, args)
        }

    }


//完整时间中 截取年月日
export function shijiantime(times){
    let timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
    let timestr = ""+timearr[0]+"/" + timearr[1] + "/" + timearr[2]
    return timestr
  }
  
  //完整时间中 截取年月日时分
  export function minutes(times){
    let timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
    // var timestr = ""+timearr[0]+"/" + timearr[1] + "/" + timearr[2]
    let timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
    return timestr
  }
  
  //完整时间中 截取年月日
  export function getYearTime(times){
    let timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
    let timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t";
    return timestr
  }